// removed by extract-text-webpack-plugin
module.exports = {"row":"_1ykFVgFwTOZ1mpajb5klHM","title":"_3BD8V10qh5x3blRwWfID7w","field":"_1PsDxV_jPA54T0qrDQdFtS","count":"_26EeJ6LI15-H8HpOQGaU1S"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/ArticleMove/style.scss
// module id = 959
// module chunks = 0